import { OrganizationDepartmentResponse } from '.generated/api';
import { IUserAccess } from 'store/models';
import { RelationItem } from 'store/models/UserAccess';

let departments: OrganizationDepartmentResponse[] | undefined;

export const getAuthorizedDepartments = (
  orgId: string,
  userAccess: IUserAccess | undefined,
  orgDepartments: OrganizationDepartmentResponse[] | null | undefined,
  accessibleDepartments: RelationItem[] | undefined,
): OrganizationDepartmentResponse[] | undefined => {
  if (
    !userAccess?.organizations?.find((org) => org.id === orgId) &&
    !userAccess?.isGlobalAdmin
  ) {
    departments = orgDepartments?.filter(
      (dept) =>
        !!accessibleDepartments?.find(
          (accessibleDept) => dept.departmentId === accessibleDept.id,
        ),
    );
  } else {
    departments = orgDepartments || undefined;
  }

  return departments;
};
